// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___D1Kkr","tile":"styles-module__tile___3XIwz","customIconDiv":"styles-module__customIconDiv___3oWTc"};